import { Component, Input, OnChanges, OnDestroy } from '@angular/core';

import { Observable ,  Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss']
})
export class CountdownComponent implements OnDestroy, OnChanges {

    @Input() date: number; // milliseconds since the Unix Epoch, e.g. Date.now() or moment().valueOf()

    minutes: string;
    seconds: string;

    private minuteUnit = 60 * 1000;

    private subscription = Subscription.EMPTY;

    constructor () { }

    ngOnChanges () {
        this.startTick();
    }

    ngOnDestroy () {
        this.stopTick();
    }

    private startTick () {

        const delay = this.diff();

        this.stopTick();

        if (delay === 0) {
            return;
        }

        const offset = delay % 1000; // calculate the milleseconds so we count at exactly the right point

        // calculate immediately
        this.tick();

        // update every second
        this.subscription = timer(offset, 1000).subscribe(() => {
            this.tick();
        });
    }

    private stopTick () {
        this.subscription.unsubscribe();
    }

    private tick () {
        const diff = this.diff();

        // calculate values
        const minutes = Math.floor(diff / this.minuteUnit);
        const seconds = Math.floor((diff - (minutes * this.minuteUnit)) / 1000);

        // use the padded versions in the UI
        this.minutes = this.pad(minutes);
        this.seconds = this.pad(seconds);

        // cancel the timer when we get to zero
        if (diff === 0) {
            this.stopTick();
        }
    }

    private pad (value: number) {
        const z = '0';
        const n = String(value);
        const width = 2;
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    private diff () {
        return Math.max((this.date || 0) - Date.now(), 0);
    }

}
